import { type Monitor, Signal } from "@suse-o11y/signal";

const openCount = Signal(0);

/**
 * Pause live data.
 *
 * @returns disposer to resume that specific pause.
 */
export function pauseLiveData(): VoidFunction {
	openCount.write((count) => count + 1);

	let released = false;

	return () => {
		if (released) {
			return;
		}

		released = true;
		openCount.write((count) => (count > 0 ? count - 1 : 0));
	};
}

/**
 * Read whether live data is currently paused.
 */
export function isLiveDataPaused(monitor: Monitor): boolean {
	return openCount.read(monitor) > 0;
}
